import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useAppStore from '../store/useAppStore';

/**
 * 与侧栏子菜单 permCode 一致：无对应权限时跳转 /forbidden，避免直链绕过。
 * 权限未成功加载前不渲染子页面（避免 hasPermission 在未加载时误返回 true）。
 */
export function RequirePagePermission({ code, children }: { code: string; children: ReactNode }) {
  const permissionsCheckDone = useAppStore((s) => s.permissionsCheckDone);
  const sitesLoaded = useAppStore((s) => s.sitesLoaded);
  const permissionsLoaded = useAppStore((s) => s.permissionsLoaded);
  const hasPermission = useAppStore((s) => s.hasPermission);

  const ready = permissionsCheckDone && sitesLoaded;
  if (!ready || !permissionsLoaded) return null;
  if (!hasPermission(code)) {
    return <Navigate to="/forbidden" replace />;
  }
  return <>{children}</>;
}
